import React from 'react';
import * as SharedAcross from './Common/SharedAcross';
import ImageUploader from "react-images-upload";
import { PhotoshopPicker } from 'react-color';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';

export function ansPieceFn(tree, setSelectionText, submitAnswer, props, onDrop, options, selectionText, thisPosition, getAPosition, width, topRow2, submitLocation, submittingPiece, isSubmitting, clickSubmitAnswer, relevantTitle, setHandTarget, handTarget, isRight, boldTarget, defaultText, pictures, setPicturePreview, setPictures, titleOverride){

    var anAnswer = tree.v[1].v;
    var questionSet = tree.v[0];

    var questionType = questionSet.v[1].v[0].v;
    var questionText = questionSet.v[2].v;
    if (!questionText){
      if (titleOverride){
        questionText = titleOverride;
      }
    }
    var answerID = anAnswer[0].v;

    if (answerID === 0){

        function keyDown(questionType){
          return function(e){
            if (e.keyCode === 13 || e.keyCode === 9){
              submitAnswer(questionType);
              // doSubmit();
              e.preventDefault();
            }

          }
        }

        function clearInput(){
          setSelectionText("");
          setPictures([]);
          setPicturePreview([]);
        }

        function changeSelectionText(e){
          setSelectionText(e.target.value);
        }

          var inputBox = null;
          var isFreeEntry = false;
          if (questionType === "9" || questionType === "12" || questionType === "15" || questionType === "16" || questionType === "18" || questionType === "27" || questionType === "28" || questionType === "29" || questionType === "30"){
            isFreeEntry = true;
          }

          var ansPieces = answerRows(answerID, questionType, isFreeEntry, width, options, topRow2, submitLocation, submittingPiece, isSubmitting, clickSubmitAnswer, clearInput, relevantTitle, setHandTarget, handTarget, isRight, boldTarget, selectionText);

          if (questionType === "18"){
            inputBox = <textarea  key="constructorTerm" autoComplete="none" autoFocus type="text" className="textFieldPieceNoColor" style={{width:"80%"}} placeholder="" value={selectionText} onChange={changeSelectionText} rows="10" cols="80"/>
          }else if (questionType === "16"){
            inputBox = <div style={{width:"100%"}} >
                        <textarea  key="constructorTerm" autoComplete="none" autoFocus type="text" className="textFieldPieceNoColor" style={{width:"80%"}} placeholder="" value={selectionText} onChange={changeSelectionText} rows="10" cols="80"/>
                          <ImageUploader
                            {...props}
                            withIcon={true}
                            withPreview={true}
                            onChange={onDrop}
                            imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                            maxFileSize={5242880}
                          />
                        </div>
//                        
          }else if (questionType === "14"){
            function onChangeComplete(color){
              setSelectionText(color.hex);
            }
            function onCancel(){
              setSelectionText(defaultText);
            }
            ansPieces = null;

            inputBox = <PhotoshopPicker color={ selectionText } onChangeComplete={ onChangeComplete } onAccept={clickSubmitAnswer(questionType)} onCancel={onCancel} />
          }else if (questionType === "27"){

            if (pictures.length === 0){
              ansPieces = null;
              inputBox = <ImageUploader
                              {...props}
                              withIcon={true}
                              singleImage={true}
                              withPreview={false}
                              onChange={onDrop}
                              imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                              maxFileSize={5242880}
                            />

            }else{
              inputBox = <div>
                  <img src={pictures[0]} style={{height:"150px"}} alt="preview"/>
                </div>
            }
//            
          }else if (questionType === "28"){
            function changeDate(date){
              var toSend = date.year()+"-"+(date.month()+1)+"-"+date.date();
              setSelectionText(toSend);
            }
            inputBox = <Datetime initialValue={Date.parse(selectionText)} timeFormat={false} onChange={changeDate}/>

          }else if (questionType === "29"){
            function changeDateTime(date){
              var utcDate = moment.utc(date);
              var toSend1 = utcDate.year()+"-"+(utcDate.month()+1)+"-"+utcDate.date()+"T"+utcDate.hour()+":"+utcDate.minute()+":"+utcDate.second() + "Z";
              setSelectionText(toSend1);
            }

            inputBox = <Datetime initialValue={Date.parse(selectionText)} onChange={changeDateTime}/>

          }else if (isFreeEntry || options.length > 12){
            inputBox = <input key="constructorTerm" autoComplete="none" autoFocus type="text" className="textFieldPieceNoColor" style={{width:"80%"}} placeholder="" value={selectionText} onChange={changeSelectionText} onKeyDown={keyDown(questionType)} />
          }
          
          return <tr><td style={{textAlign:"center", padding:"5px", backgroundColor:"#EEE", width:"100px"}}>
                    <div><b>{questionText}</b></div>
                    {inputBox}
                    <table width="100%"><tbody>
                      {ansPieces}
                    </tbody></table>
                </td></tr>
//
    }else{
      var answerText = anAnswer[1].v;
      if (+questionType === 9){
        answerText = "\"" + answerText + "\"";
      }
     return <tr key={"a" + thisPosition} onClick={getAPosition(thisPosition)} className="treeLine" style={{padding:"0px"}}><td>
          <div style={{margin:"2px"}}>{answerText}</div>
          </td></tr>
//
    }    
}

function answerRows(answerID, questionType, isFreeEntry, width, options, topRow2, submitLocation, submittingPiece, isSubmitting, clickSubmitAnswer, clearInput, relevantTitle, setHandTarget, handTarget, isRight, boldTarget, selectionText){

  function nullClick(e){
  }

  var nosCols = 4;
  if (width < 600){
    nosCols = 3;
  }
  var colWidth = (100/nosCols) + "%";
  var showEmpties = true;

  var additionalBottomRow = [];
  if (options.length === 0 && !isFreeEntry){
    additionalBottomRow.push({k:2, f:nullClick, t:"No available options"});
  }
  if (isFreeEntry){
    additionalBottomRow.push({f:clickSubmitAnswer(questionType), t:"Submit", k:3});
    if (selectionText.length > 0 || questionType === "27"){
      additionalBottomRow.push({f:clearInput, t:"Clear", k:3});
    }
  }

  var bottomRowPieces = additionalBottomRow.map((aPiece, index)=>{
      return {v:[{v:""},{v:aPiece.t},{v:1}],f:aPiece.f, k:aPiece.k};
  })

  var optionsFiltered = options.concat(bottomRowPieces);
  if (selectionText.length > 0){
    var selectionTextTrim = selectionText.trim().toLowerCase();
    optionsFiltered = optionsFiltered.filter((anOption, index)=>{
      return anOption.v[1].v.toLowerCase().indexOf(selectionTextTrim) > -1 || anOption.v[1].v === "Others" || anOption.k > 0;
    })
  }

  var optionsFiltered2 = optionsFiltered.map((aP, index)=>{return aP});

  if (optionsFiltered2.length < nosCols){
    showEmpties = false;
  }

  var convertedA = SharedAcross.convertToGrid(optionsFiltered2, nosCols, showEmpties);

  function onMouseEnter(aCell){
    return function(e){
      var questionType = +aCell.v[0].v;
      if (isRight){
        setHandTarget(questionType);
      }else{
        if (questionType === 130){
          setHandTarget(aCell.v[2].v);
        }else if (questionType === 101 || questionType === 111){
          setHandTarget(-2);
        }else if (questionType === 407){ //display prompt.
          setHandTarget(-3);
        }else if (questionType === 439){ //post display.
          setHandTarget(-4);
        }
      }
    }
  }
  function onMouseLeave(aCell){
    return function(e){
      setHandTarget(-1);
    }
  }

  var highlightedColor = "#FFB900";

  return convertedA.map((aRow, index)=>{
    var cells = aRow.map((aCell, index2)=>{
      var pretext;
        if (aCell){
          var cellStyle= {border:"1px solid gray", padding:"10px", wordWrap:"break-word", wordBreak:"break-word", whiteSpace: "normal"};
          var className = "selectionChoiceWhite";

          var cellID = aCell.v[0].v;
          var contents = aCell.v[1].v;
          var postPart = "";
          if (aCell.v.length > 2){
            postPart = aCell.v[2].v;
          }
          if (isRight){
            if (+cellID === +handTarget){
              cellStyle.backgroundColor = highlightedColor;
            }
          }else{
            if (+cellID === 130){
              if (aCell.v[2].v === handTarget){
                cellStyle.backgroundColor = highlightedColor;
              }
            }else if (+cellID === 101 || +cellID === 111){ 
              if (handTarget === -2){
                cellStyle.backgroundColor = highlightedColor;
              }
            }else if (+cellID === 407){ //question prompt
              if (handTarget === -3){
                cellStyle.backgroundColor = highlightedColor;
              }
            }else if (+cellID === 439){ //post display
              if (handTarget === -4){
                cellStyle.backgroundColor = highlightedColor;
              }
            }
          }

          if (aCell.v.length > 3){
            var colour = aCell.v[3].v;
            className = "selectionChoice" + colour;
          }
          var splitPieces = contents.split("\n");
          var out;
          var picturePiece;
          var picturePieceBreak;

          if (splitPieces.length === 1){
            out = contents;
          }else{
            out = splitPieces.map((aPiece, index3)=>{
              var aPiece1 = aPiece;
              if (aPiece === ""){
                return <div key={index3}>&nbsp;</div>
              }
//                
              return <div key={index3}>{aPiece1}</div>
//
            })
          }

          if (submittingPiece.selectedIntentID === +cellID && submittingPiece.selectedPostPart === postPart && isSubmitting){
            pretext = <div><i>Submitting...</i></div>
          }

          var outPiece = out;
          if (relevantTitle === contents){
            outPiece = <b>{out}</b>
//
          }else if (relevantTitle.indexOf("\"") === 0 && contents === "Key in Text"){
            outPiece = <b>{out}</b>
//
          }else if (relevantTitle.match(/^([+-]?[1-9]\d*|0)$/) && contents === "Key in an Integer"){
            outPiece = <b>{out}</b>
//
          }else if (boldTarget === cellID){
            outPiece = <b>{out}</b>
          }
//
          if (aCell.v.length > 4){
            if (aCell.v[4].v.length > 0){
              picturePieceBreak = <br/>
              picturePiece = <img alt="" src={aCell.v[4].v} style={{width:"80%"}}/>
            }
          }
//
//          <div style={{padding:"10px", textAlign:"center", wordWrap:"break-word"}} ></div>

          var onClick = submitLocation(aCell);
          return <td key={index2} width={colWidth} className={className} onClick={onClick} style={cellStyle} onMouseEnter={onMouseEnter(aCell)} onMouseLeave={onMouseLeave(aCell)}> 
                {pretext}
                {picturePieceBreak}
                {picturePiece}
                {picturePieceBreak}
                {outPiece}
              </td>
//
        }else{
          return <td key={index2} width={colWidth} ></td>
        }  //
    })
    return <tr key={index}>{cells}</tr>
  })
}
//
